export const STORAGE_PREFIX = '@signalwire:';
export const ADD = 'add';
export const REMOVE = 'remove';
export const SESSION_ID = 'sessId';
export var SwEvent;

(function (SwEvent) {
  SwEvent["SocketOpen"] = "signalwire.socket.open";
  SwEvent["SocketClose"] = "signalwire.socket.close";
  SwEvent["SocketError"] = "signalwire.socket.error";
  SwEvent["SocketMessage"] = "signalwire.socket.message";
  SwEvent["SpeedTest"] = "signalwire.internal.speedtest";
  SwEvent["Ready"] = "signalwire.ready";
  SwEvent["Error"] = "signalwire.error";
  SwEvent["Notification"] = "signalwire.notification";
  SwEvent["Messages"] = "signalwire.messages";
  SwEvent["Calls"] = "signalwire.calls";
  SwEvent["MediaError"] = "signalwire.rtc.mediaError";
})(SwEvent || (SwEvent = {}));

export var BladeMethod;

(function (BladeMethod) {
  BladeMethod["Broadcast"] = "blade.broadcast";
  BladeMethod["Disconnect"] = "blade.disconnect";
})(BladeMethod || (BladeMethod = {}));